import { ExpandMore, MoreVert } from "@material-ui/icons";
import React, { useState } from "react";
import { useHistory } from "react-router";
import "./DonationCard.css";
import { ReactComponent as Incognito } from "./icon.svg";
import { Modal } from "@material-ui/core";

function DonationCard({ data, categories }) {
  const history = useHistory();
  const [visible, setVisible] = useState(false);
  const [moreInfo, setMoreInfo] = useState(false);
  // console.log(categories, data.donorCategory);
  return (
    <>
      <div className="donationCard">
        {!visible && (
          <>
            <p className="donation__name">
              <span onClick={() => history.push(`/UserData/${data.userId}`)}>
                {data.donorName}
              </span>
            </p>
            <p className="donation__time">
              {data.donatedDate.toDate().toLocaleString()}
            </p>
            <p className="donation__amount">₹ {data.donatedAmount}</p>
          </>
        )}

        <img src={data?.userPhotoUrl} alt="" className="donation__donar" />
        {data.isAnonymous && (
          <Incognito
            style={{ fill: "white", cursor: "not-allowed" }}
            className="donation__icon"
          />
        )}

        {visible && (
          <div className="donation__info">
            <p
              onClick={() => {
                navigator.clipboard.writeText(data.donorPhoneNumber);
              }}
              style={{
                cursor: "copy",
              }}
            >
              Phone: {data.donorPhoneNumber}
            </p>
            <p
              onClick={() => {
                navigator.clipboard.writeText(data.orderID);
              }}
              style={{
                cursor: "copy",
              }}
            >
              {data.orderID}
            </p>
            <p
              onClick={() => {
                navigator.clipboard.writeText(data.paymentID);
              }}
              style={{
                cursor: "copy",
              }}
            >
              {data.paymentID}
            </p>
            <div style={{ textAlign: "center", width: "100%" }}>
              <ExpandMore
                fontSize="large"
                onClick={() => setMoreInfo(true)}
                style={{ color: "black", cursor: "pointer" }}
              />
            </div>
          </div>
        )}

        <Modal open={moreInfo} onClose={() => setMoreInfo(false)}>
          <div className="donation__info__modal">
            {data.message ? (
              <p className="donation__msg">"{data.message}"</p>
            ) : null}
            <p>
              <b>Name:</b> {data.donorName}
            </p>
            <p>
              <b>Phone:</b> {data.donorPhoneNumber}
            </p>
            <p>
              <b>Amount:</b> ₹ {data.donatedAmount}
            </p>
            <p>
              <b>Order ID: </b>
              {data.orderID}
            </p>
            <p>
              <b>Payment ID: </b>
              {data.paymentID}
            </p>

            <p>
              <b>Date:</b> {data.donatedDate.toDate().toLocaleString()}
            </p>
            <div>
              {categories.map((item) => {
                if (data.donorCategory[item]) {
                  // console.log(item);
                  return (
                    <p style={{ textAlign: "center" }} key={item}>
                      {item}
                    </p>
                  );
                }
                return null;
              })}
            </div>
          </div>
        </Modal>

        <div className="donations__more" onClick={() => setVisible((p) => !p)}>
          <MoreVert style={{ color: "black" }} />
        </div>
      </div>
    </>
  );
}

export default DonationCard;
